import { Link } from 'react-router-dom';
import { seoContent } from '@/mocks/content';
import { articles } from '@/mocks/articles';

export default function BlogSection() {
  return (
    <section id="artigos" className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 mb-14 md:mb-16">
          <div className="lg:w-1/3">
            <span className="text-xs md:text-sm font-semibold text-foreground-400 uppercase tracking-widest">
              {seoContent.blogTitle}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl italic text-foreground-900 mt-2">
              {seoContent.blogSubtitle}
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
              {seoContent.blogDesc}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
                  {article.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">
                  {article.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}